const DAY_MS = 86_400_000;

export function parseIsoDate(value: string): Date {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    throw new Error("La fecha debe usar el formato AAAA-MM-DD.");
  }
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    throw new Error("La fecha capturada no existe.");
  }
  return date;
}

export function calendarDaysBetween(
  startIso: string,
  endIso: string,
  inclusive = false,
): number {
  const start = parseIsoDate(startIso).getTime();
  const end = parseIsoDate(endIso).getTime();
  if (end < start) throw new Error("La fecha final no puede ser anterior a la inicial.");
  return Math.floor((end - start) / DAY_MS) + (inclusive ? 1 : 0);
}

export function isLeapYear(year: number): boolean {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

export function daysInYear(year: number): number {
  return isLeapYear(year) ? 366 : 365;
}

export function employmentAnniversary(
  startIso: string,
  endIso: string,
): {
  completedYears: number;
  currentPeriodDays: number;
  serviceDays: number;
  lastAnniversary: string;
} {
  const start = parseIsoDate(startIso);
  const end = parseIsoDate(endIso);
  if (end < start) throw new Error("La baja no puede ser anterior al ingreso.");

  let completedYears = end.getUTCFullYear() - start.getUTCFullYear();
  const anniversaryThisYear = new Date(
    Date.UTC(
      end.getUTCFullYear(),
      start.getUTCMonth(),
      Math.min(
        start.getUTCDate(),
        new Date(
          Date.UTC(end.getUTCFullYear(), start.getUTCMonth() + 1, 0),
        ).getUTCDate(),
      ),
    ),
  );
  if (end < anniversaryThisYear) completedYears -= 1;
  completedYears = Math.max(0, completedYears);

  const anniversaryYear = start.getUTCFullYear() + completedYears;
  const lastAnniversaryDate = new Date(
    Date.UTC(
      anniversaryYear,
      start.getUTCMonth(),
      Math.min(
        start.getUTCDate(),
        new Date(
          Date.UTC(anniversaryYear, start.getUTCMonth() + 1, 0),
        ).getUTCDate(),
      ),
    ),
  );

  return {
    completedYears,
    currentPeriodDays:
      Math.floor((end.getTime() - lastAnniversaryDate.getTime()) / DAY_MS) + 1,
    serviceDays: calendarDaysBetween(startIso, endIso, true),
    lastAnniversary: lastAnniversaryDate.toISOString().slice(0, 10),
  };
}

export function yearToDateEmploymentDays(
  startIso: string,
  endIso: string,
): number {
  const end = parseIsoDate(endIso);
  const yearStart = `${end.getUTCFullYear()}-01-01`;
  const effectiveStart = startIso > yearStart ? startIso : yearStart;
  return calendarDaysBetween(effectiveStart, endIso, true);
}

